import React, { useEffect, useState } from "react";
import { Alert, Button, Form, Modal, Table } from "react-bootstrap";
import api from "../../../axiosConfig";

const labels = { m1: "M1", m2: "M2", m3: "M3", m4: "M4", m5: "M5 / Scanări" };
const message = (e) => typeof e.response?.data?.detail === "string" ? e.response.data.detail : "Nu s-au putut salva contoarele. Verificați valorile introduse.";

export default function CounterHistory({ id }) {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [editing, setEditing] = useState(false);
  const [values, setValues] = useState({});
  const [reason, setReason] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    let active = true;
    setData(null);
    setError("");
    if (id) api.get(`/contor/sesizari/${id}/contoare`).then(r => {
      if (active) setData(r.data);
    }).catch(e => { if (active) setError(message(e)); });
    return () => { active = false; };
  }, [id]);

  const save = async () => {
    const numeric = Object.fromEntries(Object.keys(labels).map(k => [k, Number(values[k])]));
    if (Object.keys(labels).some(k => values[k] === "" || !Number.isSafeInteger(numeric[k]) || numeric[k] < 0 || numeric[k] > 2147483647) || reason.trim().length < 3) {
      setError("Completați contoarele cu numere întregi pozitive sau zero și precizați motivul.");
      return;
    }
    setSaving(true);
    setError("");
    try {
      const r = await api.put(`/contor/sesizari/${id}/contoare`, { valori: numeric, revizie: data.revizie, motiv: reason.trim() });
      setData(r.data);
      setEditing(false);
    } catch (e) { setError(message(e)); }
    finally { setSaving(false); }
  };

  return <div className="mt-4">
    <h6>Contoare vechi și istoricul corecțiilor</h6>
    {!id && <p className="text-muted">Salvați sesizarea înainte de stabilirea contoarelor vechi de către administrator.</p>}
    {error && !editing && <Alert variant="danger">{error}</Alert>}
    {data && <>
      {data.revizie === 0 && <Alert variant="info">Contoarele vechi nu sunt încă stabilite. Lipsa valorii nu înseamnă zero. Preluarea automată din facturile CONTOR va fi disponibilă odată cu facturarea din contracte.</Alert>}
      <Table size="sm" bordered responsive>
        <thead><tr>{Object.values(labels).map(label => <th key={label}>{label}</th>)}</tr></thead>
        <tbody><tr>{Object.keys(labels).map(k => <td key={k}>{data.valori[k] ?? "Nestabilit"}</td>)}</tr></tbody>
      </Table>
      {data.poate_corecta && <Button type="button" variant="outline-warning" onClick={() => {
        setValues(Object.fromEntries(Object.keys(labels).map(k => [k, data.valori[k] ?? ""])));
        setReason(""); setError(""); setEditing(true);
      }}>Corectează contorul vechi</Button>}
      <p className="text-muted small mt-2">Doar administratorul poate modifica aceste valori, cu motiv. Corecția nu modifică facturile deja emise. Salvați mai întâi orice schimbare a citirilor noi.</p>
      {data.istoric.length > 0 && <details className="mt-2"><summary>Istoric corecții ({data.istoric.length})</summary>
        {data.istoric.map(h => <div key={h.revizie} className="border rounded p-2 my-2">
          <strong>{h.utilizator}</strong> — {new Date(h.creat_la).toLocaleString("ro-RO")}
          <div>{h.motiv}</div>
          <div className="small">{Object.keys(labels).filter(k => h.inainte[k] !== h.dupa[k]).map(k => `${labels[k]}: ${h.inainte[k] ?? "Nestabilit"} → ${h.dupa[k]}`).join("; ")}</div>
        </div>)}
      </details>}
    </>}
    <Modal show={editing} onHide={() => !saving && setEditing(false)}>
      <Modal.Header closeButton={!saving}><Modal.Title>Corectare contoare vechi</Modal.Title></Modal.Header>
      <Modal.Body>
        {error && <Alert variant="danger">{error}</Alert>}
        {Object.entries(labels).map(([key, label]) => <Form.Group key={key} controlId={`old-${key}`} className="mb-2">
          <Form.Label>{label}</Form.Label>
          <Form.Control type="number" min="0" step="1" value={values[key] ?? ""} disabled={saving}
            onChange={e => setValues({ ...values, [key]: e.target.value })} />
        </Form.Group>)}
        <Form.Group controlId="counter-reason"><Form.Label>Motivul corecției</Form.Label>
          <Form.Control as="textarea" maxLength={1000} value={reason} disabled={saving} onChange={e => setReason(e.target.value)} />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer><Button variant="secondary" disabled={saving} onClick={() => setEditing(false)}>Renunță</Button>
        <Button disabled={saving} onClick={save}>{saving ? "Se salvează…" : "Salvează corecția"}</Button></Modal.Footer>
    </Modal>
  </div>;
}
